import styled from "styled-components";

const StyledInformationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 115px;
    background: #fff;
    margin-top: 20px;
    border-radius: 8px;
`;

const StyledInfoTextContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: left;
    flex-direction: column;
`;

const StyledTeacherInfo = styled.span`
    font-weight: 600;
    font-size: 17px;
    color: #1e1e1e;
    margin: 5px 20px;
    text-align: left;
`;

const StyledPeriodInfo = styled.span`
    font-weight: 400;
    font-size: 15px;
    color: #000;
    margin: 5px 20px;
    text-align: left;
`;

const StyledCheckboxFlexDiv = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0;
    gap: 5px;
`;

const StyledCheckboxText = styled.span`
    color: #787878;
    font-size: 15px;
    font-weight: 400;
    margin-top: 4px;
`;

const StyledLabelTach = styled.label`
    color: #000;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px;
    width: 100%;
    text-align: left;
`;

const StyledBtnsContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 30px;
`;

const StyledActionContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
`;

const StyledPdfContainer = styled.div`
    height: 100vh;
    border-radius: 8px;
    background-color: #fff;
    margin-top: 10px;
`;

const StyledDivActionViewTach = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
`;

export {
    StyledInformationContainer,
    StyledInfoTextContainer,
    StyledTeacherInfo,
    StyledPeriodInfo,
    StyledCheckboxFlexDiv,
    StyledCheckboxText,
    StyledLabelTach,
    StyledBtnsContainer,
    StyledActionContainer,
    StyledPdfContainer,
    StyledDivActionViewTach,
};
